import { createContext, useContext } from 'react';

export interface JsonFormContextValue {
    translationPrefix: string;
}

export const JsonFormExternalConfigContext = createContext<JsonFormContextValue>(null as any);

export const useJsonFormExternalConfig = () => {
    const config = useContext(JsonFormExternalConfigContext);

    if (!config) {
        throw new Error(
            'JsonFormExternalConfigProvider not set. Please wrap your component with JsonFormExternalConfigProvider.',
        );
    }

    return config;
};

export const JsonFormExternalConfigProvider = JsonFormExternalConfigContext.Provider;
